import { ENDPOINT } from '~/constants';

import { type UUID } from '~/types/common';

import { HTTPError, vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

import { type InvoiceForwardingReasonsResponse } from './types';

/**
 * Fetches the defined list of reasons for forwarding an invoice.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Invoice/operation/get_forward_reasons_invoice_process__process_id__forward_reasons_get
 */
export async function fetchInvoiceForwardingReasons(processId: UUID) {
  try {
    const response = await vestigasApi
      .get(ENDPOINT.INVOICE_REPROCESSING.GET_FORWARDING_REASONS(processId))
      .json<InvoiceForwardingReasonsResponse>();

    return response;
  } catch (error) {
    if (error instanceof HTTPError && error.response.status === 404) {
      // A 404 error is expected if the invoice has no forwarding reasons
      return undefined;
    }

    log.error({
      message: 'Error fetching invoice forwarding reasons',
      error,
    });

    let errorMessage = '';

    if (error instanceof HTTPError) {
      errorMessage = i18n.t(
        ($) =>
          $.invoiceReprocessingQueries.fetchInvoiceForwardingReasons.error
            .generic,
        { ns: 'data' },
      );
    }

    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
}
